import React from 'react';
import { usePagination } from 'react-instantsearch';

const Pagination = (props) => {

    // eslint-disable-next-line no-unused-vars
    const {pages, currentRefinement, nbHits, nbPages, isFirstPage, isLastPage, canRefine, refine, createURL } = usePagination(props);
    const firstPageIndex = 0;
    const previousPageIndex = currentRefinement - 1;
    const nextPageIndex = currentRefinement + 1;
    const lastPageIndex = nbPages - 1;

    if (nbPages > 1) {

        return (
            <nav className="relative z-0 inline-flex md:text-lg">
                {/* eslint-disable-next-line multiline-ternary */}
                { currentRefinement != firstPageIndex ?
                    // eslint-disable-next-line multiline-ternary
                    <a
                        href={createURL(previousPageIndex)}
                        onClick={(e) => {
                            e.preventDefault();
                            // document.getElementById('listing').scrollIntoView({behavior:'instant'})
                            refine(previousPageIndex);
                        }}
                        className="relative inline-flex items-center px-2 py-2 leading-5 font-normal text-grey transition ease-linear duration-300 hover:text-green"
                        aria-label="Previous"
                    >
                        <span className="sr-only">Previous page</span>
                        <svg width="13" height="22" viewBox="0 0 13 22" xmlns="http://www.w3.org/2000/svg"><path fill="currentColor" fillRule="nonzero" d="M10.955 21.207l1.426-1.402L3.41 10.68l8.966-8.967L10.961.3.591 10.669z"/></svg>
                    </a>
                    : <div></div> }

                {pages.map((page) => {
                    const className = 'relative inline-flex items-center px-4 py-2 leading-5 font-normal transition ease-linear duration-300 hover:text-green ' + (page == currentRefinement ? 'text-white bg-grey rounded-sm' : 'text-grey');

                    return (
                        <a
                            key={page}
                            href={createURL(page)}
                            onClick={(e) => {
                                e.preventDefault();
                                // document.getElementById('listing').scrollIntoView({behavior:'instant'})
                                refine(page);
                            }}
                            className={className}
                        >
                            {page + 1}
                        </a>
                    );
                })}

                {/* eslint-disable-next-line multiline-ternary */}
                { currentRefinement != lastPageIndex ?
                    // eslint-disable-next-line multiline-ternary
                    <a
                        href={createURL(nextPageIndex)}
                        onClick={(e) => {
                            e.preventDefault();
                            // document.getElementById('listing').scrollIntoView({behavior:'instant'})
                            refine(nextPageIndex);
                        }}
                        className="relative inline-flex items-center px-2 py-2 leading-5 font-normal text-grey transition ease-linear duration-300 hover:text-green"
                        aria-label="Next"
                    >
                        <span className="sr-only">Next page</span>
                        <svg className="h-5" width="12" height="22" viewBox="0 0 12 22" xmlns="http://www.w3.org/2000/svg"><path fill="currentColor" fillRule="nonzero" d="M1.644 21.207L.218 19.805 9.19 10.68.224 1.713 1.638.3l10.37 10.37z"/></svg>
                    </a>
                    : <div></div> }
            </nav>
        );
    } else {
        return <></>;
    }
}

const PaginationButtons = (props) => {
    // eslint-disable-next-line no-unused-vars
    const {pages, currentRefinement, nbHits, nbPages, isFirstPage, isLastPage, canRefine, refine, createURL } = usePagination(props);
    const firstPageIndex = 0;
    const previousPageIndex = currentRefinement - 1;
    const nextPageIndex = currentRefinement + 1;
    const lastPageIndex = nbPages - 1;

    return (
        <div className={`flex-1 flex flex-wrap gap-6 ${currentRefinement != firstPageIndex && currentRefinement != lastPageIndex ? 'justify-between' : 'justify-center'}`}>
            {/* eslint-disable-next-line multiline-ternary */}
            { currentRefinement != firstPageIndex ?
                // eslint-disable-next-line multiline-ternary
                <div>
                    <a
                        href={createURL(previousPageIndex)}
                        onClick={(e) => {
                            e.preventDefault();
                            // document.getElementById('listing').scrollIntoView({behavior:'instant'})
                            refine(previousPageIndex);
                        }}
                        data-spinner=""
                        target="_self"
                        className="relative border rounded-sm text-center text-sm inline-flex items-center justify-center truncate w-full transition ease-linear duration-300 min-w-[120px] sm:w-auto md:text-[0.9375rem] lg:text-base bg-grey border-grey text-white hover:bg-green hover:border-green h-11 px-4 leading-snug">
                        <span className="button-text">{props.previous}</span>
                        <span className="button-spinner  mt-1.5 absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 transform hidden">
                            <span className="spinner"></span>
                        </span>
                    </a>
                </div>
                : '' }
            {/* eslint-disable-next-line multiline-ternary */}
            { currentRefinement != lastPageIndex ?
                // eslint-disable-next-line multiline-ternary
                <div>
                    <a
                        href={createURL(nextPageIndex)}
                        onClick={(e) => {
                            e.preventDefault();
                            // document.getElementById('listing').scrollIntoView({behavior:'instant'})
                            refine(nextPageIndex);
                        }}
                        data-spinner=""
                        target="_self"
                        className="relative border rounded-sm text-center text-sm inline-flex items-center justify-center truncate w-full transition ease-linear duration-300 min-w-[120px] sm:w-auto md:text-[0.9375rem] lg:text-base bg-grey border-grey text-white hover:bg-green hover:border-green h-11 px-4 leading-snug">
                        <span className="button-text">{props.next}</span>
                        <span className="button-spinner  mt-1.5 absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 transform hidden">
                            <span className="spinner"></span>
                        </span>
                    </a>
                </div>
                : '' }
        </div>
    );
}

export { Pagination, PaginationButtons }
